import React from "react";
import WebStoreInquiry from "./WebStoreInquiry";

const AboutUs = ({aboutUs}) => {
  return (
    <>
    <div className="w-full bg-white">
      <div className="container max-w-[1240px] mx-auto w-full h-[175px] flex flex-col">
        <h3 className="w-[83px] h-[27px] font-semibold text-[18px] text-black text-start">
          About Us
        </h3>
        <hr className="w-[151px] h-[3px] bg-[#FF6300] text-start mt-[8px]" />
        <p className="mt-[23px] w-[1214px] h-[84px] text-start text-black font-medium text-[16px] leading-[30px]">
          {aboutUs}
        </p>
        </div>
      </div>
      {/* <WebStoreInquiry /> */}
    </>
  );
};

export default AboutUs;
